import { render } from "./DisabilityInfo.vue?vue&type=template&id=51e57f69&scoped=true"
import script from "./DisabilityInfo.vue?vue&type=script&lang=js"
export * from "./DisabilityInfo.vue?vue&type=script&lang=js"

import "./DisabilityInfo.vue?vue&type=style&index=0&id=51e57f69&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e57f69"]])

export default __exports__